import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import {Location} from '@angular/common'
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { PageHelperService } from '../helpers/page-helper.service';
import { AssetService, AssetTypeClassification, AssetTypeGroupDto, CurrentAssetLocationDto, CustomerLocationDto, GraphDataSeriesModel, IntegrationReportDataDto, JourneyItemDto, LocationDetailsService, LocationServiceDto } from 'src/shared/service-proxies/service-proxies';
import { PagebaseComponent } from '../pagebase/pagebase.component';
import { ApplicationStatusService } from '../services/application-status.service';
import * as L from 'leaflet';
import { AssetOnSiteModel, GroupedAssetOnSiteModel } from './assets-on-site-model';
import { PagingModel } from '../widgets/models/paging-model';
import { LocationClassNameHelper, LocationTypeNames } from '../enums/LocationTypeNames';
import { CustomerSettings } from '../services/customer-settings-service';
import { DropDownListItem } from '../dashboard-live/dashboard-live.component';
import { SessionStorageService } from '../services/session-storage.service';
import moment from 'moment';

export class ContainerSummary {
  constructor(name: string, assetTypeClassification: AssetTypeClassification, count: number) {
    this.groupName = name;
    this.assetTypeClassification = assetTypeClassification;
    this.count = count;
  }
  assetTypeClassification: AssetTypeClassification = null;
  groupName: string = "";
  count: number = 0;
}


@Component({
    selector: 'app-location-detail',
    templateUrl: './location-detail.component.html',
    styleUrls: ['./location-detail.component.scss'],
    standalone: false
})
export class LocationDetailComponent extends PagebaseComponent implements OnInit {
  
  
  @ViewChild('mapdiv')
  mapDiv: ElementRef;
  locationDataLoaded: boolean = false;  
  loading: boolean = false;
  location: CustomerLocationDto = {
    id: null,
    name: null,
    locationType: null,
    locationTypeClassification: null,
    secondaryLocationType: null,
    secondaryLocationTypeClassification: null,
    latitude: null,
    longitude: null,
    geofenceRadius: null,
    displayName: null,
    depotId: null,
    depotName: null,
    customerId: null,
    isRental: null,
    postCode: null,
    hasAgreement: null,
    agreementCustomerName: null,
    agreementSiteName: null,
    agreementAddress1: null,
    agreementAddress2: null,
    agreementAddress3: null,
    agreementAddress4: null,
    agreementPostcode: null,
    isDeleted: null,
    customerRegionId: null,
    customerRegionName: null,
    canHaveOwnBin: false,
    isPositionAutoSet: false,
    hasFixedBins: false
};
  hasSkips: boolean = false;
  hasRoRo: boolean = false;
  assetsOnSite: AssetOnSiteModel[] = [];
  groupedAssetsOnSite: GroupedAssetOnSiteModel[] = [];
  jobs: JourneyItemDto[] = []
  jobsPaging: PagingModel;
  services: LocationServiceDto[] = []
  servicesPaging: PagingModel;
  isDepot: boolean;
  totalOrders?: number = null;
  locationSkipGroups: ContainerSummary[] = [];
  locationRoRoGroups: ContainerSummary[] = [];
  openType: string = "";
  isPopupOpen = false;
  selectedImage: string | null = null;
  selectedVehicleId: string[];
  customerVehicles: DropDownListItem[];
  maxDate: Date = new Date();
  selectedStartDate: Date;
  selectedEndDate: Date;
  isIntegrationCustomer: boolean = false;
  detailsLoaded: boolean = false;
  journeysLoaded: boolean = false;
  servicesLoaded: boolean = false;


  // Private variables
  private locationId: string;
  private firstInit: boolean = true;
  
  // Map
  private map;
  private mapLayer = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      maxZoom: 18,
      minZoom: 3,
      attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
  });
  private drawLayer = L.layerGroup();

  // Chart
  avgTurnaroundSubTitle = "";
  avgTurnaroundColour = "#2878ff";
  averageTurnaroundData: GraphDataSeriesModel[] = [];
  
  avgDwellSubTitle = "";
  avgDwellColour = "#00c17f";
  averageDwellData: GraphDataSeriesModel[] = [];

  longestBinColour: '#ff0000';
  longestBin: AssetOnSiteModel
  containerGroups: AssetTypeGroupDto[] = [];

  constructor(
    private browserLocation: Location,
    private router: Router,
    pageHelperService: PageHelperService,
    private locationDetailsService: LocationDetailsService,
    applicationStatusService: ApplicationStatusService,
    private route: ActivatedRoute,
    private customerSettings: CustomerSettings,
    private sessionStorageService: SessionStorageService) { 
      super(pageHelperService, applicationStatusService, customerSettings, "Live Operations");
    }

  ngOnInit() {
    this.route.params.subscribe(({ id }) => {
      if (!this.firstInit) {
        this.locationDataLoaded = false;
        this.getData(false);
      }
    });
    this.firstInit = false;
  }  
  
  ngOnDestroy(): void {
    if (this.map ){
      this.map.eachLayer(function(layer){
          layer.remove();
      });
      this.map.remove();
      this.map = null;
      this.mapDiv.nativeElement.innerHTML = "";
    }
  }

  getData(companyChange: boolean) {
    this.locationId = this.route.snapshot.paramMap.get('id');
    this.loading = true;
    this.setIsLoading(this.loading);

    this.locationDetailsService.getLocationDetails(this.locationId, this.pageHelperService.selectedCompanyId, false).subscribe(data => 
    {
      this.detailsLoaded = true;
      this.containerGroups = data.containerGroups;
      this.pageHelperService.setPageTitle(data.location.displayName);
      this.location = data.location;
      this.isDepot = data.location.locationType == LocationTypeNames.Depot;
      this.assetsOnSite = data.assetsOnSite.sort(function(a, b) {
        return b.daysAtLocation - a.daysAtLocation
      }).map(a => new AssetOnSiteModel(a));
      this.locationDataLoaded = true;
      if (data.averageDwellGraphData[0].series.length > 0) {
        this.avgDwellSubTitle = data.averageDwellGraphData[0].series[data.averageDwellGraphData[0].series.length - 1].value + " Days";
      } else {
        this.avgDwellSubTitle = "N/A"
      }
      this.averageDwellData = data.averageDwellGraphData;
      
      if (data.averageTurnAroundGraphData[0].series.length > 0) {
        this.avgTurnaroundSubTitle = data.averageTurnAroundGraphData[0].series[data.averageTurnAroundGraphData[0].series.length - 1].value + " Minutes";
      } else {
        this.avgTurnaroundSubTitle = "N/A"
      }
      this.averageTurnaroundData = data.averageTurnAroundGraphData;
      if (this.assetsOnSite.length > 0) {
        this.longestBin = this.assetsOnSite[0];
        this.longestBinColour = '#ff0000';
      }

      data.assetsOnSite.forEach(container => {
        // Get container tpye goup counts
        var group = this.containerGroups.find(containerGroup => containerGroup.assetTypes.some(type => type.name === container.assetType));
        if (group && group.assetTypeClassification === AssetTypeClassification.Skip) {
          const existingGroup = this.locationSkipGroups.find(cg => cg.groupName == group.name);
          if(existingGroup) {
            existingGroup.count += 1;
          } else {
            this.hasSkips = true;
            this.locationSkipGroups.push(new ContainerSummary(group.name, AssetTypeClassification.Skip, 1));
          }
        }
        if (group && group.assetTypeClassification === AssetTypeClassification.RoRo) {
          const existingGroup = this.locationRoRoGroups.find(cg => cg.groupName == group.name);
          if(existingGroup) {
            this.locationRoRoGroups.find(cg => cg.groupName == group.name).count += 1;
          } else {
            this.hasRoRo = true;
            this.locationRoRoGroups.push(new ContainerSummary(group.name, AssetTypeClassification.RoRo, 1));
          }
        }
      });

      // Set up integration
      this.assetsOnSite.forEach(container => {
        this.addIntegrationDetail(container, data.orderData);
      })

      if (this.isIntegrationCustomer) {
        var groupedAssetsOnSite : GroupedAssetOnSiteModel[] = [];
        this.assetsOnSite.forEach(container => {
          let groupedAsset = groupedAssetsOnSite.find(a => a.order == container.order);
          if (!groupedAsset) {
            groupedAsset = new GroupedAssetOnSiteModel();
            groupedAsset.order = container.order;
            groupedAssetsOnSite.push(groupedAsset);
          }

          groupedAsset.assetsOnSite.push(container);
        });

        this.groupedAssetsOnSite = groupedAssetsOnSite;
      }

      this.totalOrders = groupedAssetsOnSite ? groupedAssetsOnSite.length : 0;
      this.loading = false;
      this.setIsLoading(this.loading);
    });

    this.changeJobsPage(this, 1);
    this.changeServicesPage(this, 1);
  }

  reset() {

  }

  back(): void {
    this.ngOnDestroy();
    this.browserLocation.back()
  }

  toggleSummaryRow(type) {
    if (this.openType == type) {
      this.openType = "";
      return;
    }

    this.openType = type;
  }

  changeJobsPage(self: any, page: number) {
    self.setBlackboxIds();
    self.setDates();
    console.log(self.selectedVehicleId);
    const request = {
      locationId: self.locationId,
      customerId: self.pageHelperService.selectedCompanyId,
      startDate: self.selectedStartDate,
      endDate: self.selectedEndDate,
      blackBoxIds: self.selectedVehicleId,
      pageSize: 20,
      pageId: page
    }
    self.locationDetailsService.getLocationJourneys(request).subscribe(data => 
      {
        self.jobs = data.items;
        self.jobsPaging = new PagingModel(data.currentPage, data.hasNext, data.hasPrevious, data.pageSize, data.totalPages, data.totalTotalItemCount);
        self.loadListData(data.items);
        self.journeysLoaded = true;
      });
  }

  changeServicesPage(self: any, page: number) {
    self.setBlackboxIds();
    self.setDates();
    const request = {
      locationId: self.locationId,
      customerId: self.pageHelperService.selectedCompanyId,
      startDate: self.selectedStartDate,
      endDate: self.selectedEndDate,
      blackBoxIds: self.selectedVehicleId,
      pageSize: 20,
      pageId: page
    }
    self.locationDetailsService.getLocationServices(request).subscribe(data => 
      {
        self.services = data.items;
        self.servicesPaging = new PagingModel(data.currentPage, data.hasNext, data.hasPrevious, data.pageSize, data.totalPages, data.totalTotalItemCount);
        self.servicesLoaded = true;
      });
  }

  addIntegrationDetail(onSiteContainer: AssetOnSiteModel, orderData: IntegrationReportDataDto) {
    this.isIntegrationCustomer = orderData.agreements.items.length > 0;
    var agreement = orderData.agreements.items.find(agreement => agreement.containers.some(container => container.name == onSiteContainer.id))

    if (agreement) {
      onSiteContainer.isIntegration = true;
      onSiteContainer.order = agreement.reference
      onSiteContainer.wasteTypeName = agreement.wasteTypeName;
    }
  }

  setBlackboxIds() {
    var selectedVehicleId = [];
    if (this.sessionStorageService.getItem("location-selectedVehicleId")) {
      selectedVehicleId = JSON.parse(this.sessionStorageService.getItem("location-selectedVehicleId"));
      this.selectedVehicleId = selectedVehicleId;
    }

    this.selectedVehicleId = selectedVehicleId;
  }

  setDates() {
    var selectedStartDate = this.getDateFromValue(this.sessionStorageService.getItem("location-selectedStartDate"), false);
    this.selectedStartDate = selectedStartDate;

    var selectedEndDate = this.getDateFromValue(this.sessionStorageService.getItem("location-selectedEndDate"), true);
    this.selectedEndDate = selectedEndDate;
  }

  vehicleChange(newValue) {
    if (newValue.length > 0) {
      this.sessionStorageService.setItem("location-selectedVehicleId", JSON.stringify(newValue));
    } else {
      this.sessionStorageService.removeItem("location-selectedVehicleId")
    }
  }

  getDateFromValue(newValue, isEndDate: boolean): Date {
    if (newValue == null) {
      var now = new Date();
      if (isEndDate) {
        return new Date(Date.UTC(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59));
      }

      var endDate = new Date(Date.UTC(now.getFullYear(), now.getMonth() - 6, now.getDate(), 0, 0, 0))
      endDate.setMonth(endDate.getMonth() - 6);
      return endDate;
    }

    if (newValue && newValue != null) {
      var milliseconds = newValue;
      newValue = new Date(0);
      newValue.setUTCMilliseconds(milliseconds)
    } else {
      newValue = new Date();
    }

    return new Date(Date.UTC(newValue.getFullYear(), newValue.getMonth(), newValue.getDate(), 0, 0, 0));
  }

  selectedEndDateChange(startDate, endDate) {
    if (startDate.value && endDate.value) {
      var startMoment = moment(startDate.value, 'DD/MM/YYYY');
      var endMoment = moment(endDate.value, 'DD/MM/YYYY');
      startDate = startMoment.toDate();
      endDate = endMoment.toDate();

      var utcStart = new Date(Date.UTC(startDate.getFullYear(), startDate.getMonth(), startDate.getDate(), 0, 0, 0));
      this.sessionStorageService.setItem("location-selectedStartDate", utcStart.valueOf().toString());
      console.log(startDate)
      console.log(this.selectedStartDate)

      var utcEnd = new Date(Date.UTC(endDate.getFullYear(), endDate.getMonth(), endDate.getDate(), 23, 59, 59));
      this.sessionStorageService.setItem("location-selectedEndDate", utcEnd.valueOf().toString());
      console.log(endDate);
      console.log(this.selectedEndDate);


      // Rset vehicle and location filters
      this.selectedVehicleId = [];
      this.sessionStorageService.removeItem("location-selectedVehicleId")
    
      this.changeJobsPage(this, 1);
      this.changeServicesPage(this, 1);
    }
  }


  loadListData(data: JourneyItemDto[]) {
    // Get list data from the provided data
    const vehicles: DropDownListItem[] = [];

    data.forEach(job => {
      // Add vehicles
      if (job.vehicleId != null) {
        if (!vehicles.find(l => l.id == job.vehicleId)) {
          var vehicle = new DropDownListItem()
          vehicle.id = job.vehicleId;
          vehicle.name = job.vehicleName;
          vehicles.push(vehicle)
        }
      }

    });

    this.customerVehicles = vehicles.sort(function (a, b) {
      if (a.name < b.name) { return -1; }
      if (a.name > b.name) { return 1; }
      return 0;
    })

    

    var selectedVehicleId = [];
    if (this.sessionStorageService.getItem("location-selectedVehicleId")) {
      selectedVehicleId = JSON.parse(this.sessionStorageService.getItem("location-selectedVehicleId"));
      this.selectedVehicleId = selectedVehicleId;
    }
  }

  dropdownChanged(opened) {
    if (!opened) {
      this.changeJobsPage(this, 1);
      this.changeServicesPage(this, 1);
    }
  }

  getTypeTotal(items: ContainerSummary[]) {
    const totalAmount = items.reduce((sum, currentItem) => sum + currentItem.count, 0);
    return totalAmount;
  }

  openPopup(imageSrc: string): void {
    this.selectedImage = imageSrc;
    this.isPopupOpen = true;
  }

  closePopup(): void {
    this.isPopupOpen = false;
  }
}
